import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import { AppSettingsService } from './app-settings.service';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class UserService {

  private apiEndpoint;
  constructor(private http: HttpClient, private notificationService: NotificationsService, private AppSettings: AppSettingsService, private authService: AuthService) {
    this.apiEndpoint = this.AppSettings.getConfig('API_ENDPOINT');
  }


  saveUser(data): Observable<any> {
    return this.http.post<any>(this.apiEndpoint + 'users/AddOrModifyUser', data).map(response => {
      return response;
    });
  }

  deleteUser(loggedinuserid, deleteduserid): Observable<any> {
    return this.http.delete<any>(this.apiEndpoint + 'users/DeleteUser?loggedinuserid=' + loggedinuserid + '&deleteduserid=' + deleteduserid).map(response => {
      return response;
    });
  }

  getUserList(): Observable<any> {
    return this.http.get<any>(this.apiEndpoint + 'Users/list').map(response => {
      return response;
    });
  }

  getUserRoleList(): Observable<any> {
    return this.http.get<any>(this.apiEndpoint + 'Users/Role').map(response => {
      return response;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts